import { connect } from 'react-redux';

import MediaLibraryPage from 'src/pages/MediaLibrary';

export type { MediaLibraryContainerProps } from './connectToMediaLibraryState';
export { connectToMediaLibraryState } from './connectToMediaLibraryState';
import { mapStateToProps, mapDispatchToProps } from './connectToMediaLibraryState';

export default connect(mapStateToProps, mapDispatchToProps)(MediaLibraryPage);
